// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modalHead[data-v-0dc3beff] {\n  color: #000;\n  font-size: 20px;\n  text-align: left;\n}\n.modalContent[data-v-0dc3beff] {\n  text-align: left;\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
